import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AuthService } from '@services/auth/auth.service';
import { NemThemeService } from '@services/theme/theme.service';

@Component({
  selector: 'nem-top-menu',
  templateUrl: './top-menu.comp.html',
  standalone: false,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class:
      'sticky top-0 z-50 w-full flex-none bg-white/80 dark:bg-[#0f0e1c]/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-800 transition-colors duration-300'
  }
})
export class TopMenuComponent {
  navigation = toSignal(this._authService.navigation$, { initialValue: [] });
  themeService = inject(NemThemeService);
  sidebarVisible = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _authenticator: AuthenticatorService
  ) {}

  get authenticated(): boolean {
    return this._authenticator.authStatus === 'authenticated';
  }

  async onSignOut() {
    // Appel direct de la méthode (plus besoin de wrapper HTML !)
    this._authenticator.signOut();
    await this._router.navigate(['/']);
  }
}
